module.exports = __webpack_public_path__ + "a1957145134931ef35a8100cda5ad078.png";